import { mutateApi } from '@lib/query/api.config'

export type QuestionChoiceType = { questionNumber: number; choice: number }
export type checkInformationQueryType = {
  questionGroupId: number
  questionChoices: QuestionChoiceType[]
}
export type DailyQuestionChoiceType = {
  questionId: number
  choice: number
}
export type CheckDailyQuestionQueryType = {
  dailyDeliveryId: number
  questionChoices: DailyQuestionChoiceType[]
}

export type checkAffiliateCodeType = {
  code: string
}

export type DailyQuestionResult = {
  id: number
  choice: number
  answer: number
  result: boolean
  explanationId: number
}

export const checkQuestionChoice = () => async (query: checkInformationQueryType) => {
  return await mutateApi('/question/check', 'POST', query)
}

export const checkAffiliateCode = () => async (query: checkAffiliateCodeType) => {
  return await mutateApi('/affiliate-code/check', 'POST', query)
}

export const createUserCode = () => async (query: checkAffiliateCodeType) => {
  return await mutateApi('/affiliate-code/usercode', 'POST', query)
}

export const checkDailyQuestionChoice =
  () =>
  async (query: CheckDailyQuestionQueryType): Promise<DailyQuestionResult[]> => {
    return await mutateApi('/question/daily/check', 'POST', query)
  }

export const createOrUpdateTodayDailyDeliveryStatus = () => async (query: { status: string }) => {
  return await mutateApi('/daily-status', 'POST', query)
}
